//messages.js
export default {
    tank_types: "Tipos de tanques",
    delete_tank_type: "Eliminar tipo de tanque",
    add_tank_type: "Agregar tipo de tanque",
    edit_tank_type: "Editar tipo de tanque",
    image_url: "URL de imagen",
    tank_type: "Tipo de tanque",
    slug: "Babosa",
    formula: "Fórmula",
    comments: "Comentarios",
};
